<template><div><h1 id="auftrage-und-dokumente" tabindex="-1"><a class="header-anchor" href="#auftrage-und-dokumente"><span>Aufträge und Dokumente</span></a></h1>
<p>Aufträge und Dokumente — Aufträge und Printoutput-Dokumente zu Fakturierungslauf</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Hier werden alle erstellten Aufträge zum <RouteLink to="/referenz/refs/ft.refdata.wbsjob.html" title="Fakturen/Avis aufbereiten">Fakturierungslauf</RouteLink> angezeigt. Als Child werden die erstellten Dokumente angezeigt, die mit rechter Maustaste geöffnet werden können.</p>
<p>Pfad: <code v-pre>Verkauf → Verarbeitungsläufe → Fakturen/Avis verarbeiten → Fakturen/Avis aufbereiten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Auftragsnummer</dt>
<dd>ID des Auftrages</dd>
<dt>Auftraggeber</dt>
<dd>Personen-ID des Auftraggebers</dd>
<dt>Jobdatum/Laufnummer</dt>
<dd>ID des Fakturierungsjobs</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Als Child sind die erstellten <RouteLink to="/referenz/refs/ft.refdata.dokumente.html" title="Dokumente">Dokumente</RouteLink> angehängt.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.dokumente.html" title="Dokumente">Dokumente</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.wbsjob.html" title="Fakturen/Avis aufbereiten">Fakturierungslauf</RouteLink></p>
</div></template>


